import { make } from 'vuex-pathify'
import axios from 'axios'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'

const state = {
  rules: {
    count: 0,
    data: [],
  },
  loading: false,
  filter: {
    page: 1,
    itemsPerPage: 20,
  },
}

const mutations = make.mutations(state)

const actions = {
  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    const currentCompany = store.get('authStore@currentCompany')
    const payload = { companyId: currentCompany?.id, ...filter }

    return axios.get(`${process.env.VUE_APP_API_URL}/product-fiscal-state-rules?${getQueryFromFilter(payload)}`)
      .then(res => {
        state.rules = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  save: async ({ state, dispatch }, rule) => {
    state.loading = true
    const currentCompany = store.get('authStore@currentCompany')
    const payload = { ...rule, companyId: rule.companyId || currentCompany?.id }
    const method = payload.id ? 'put' : 'post'
    const url = `${process.env.VUE_APP_API_URL}/product-fiscal-state-rules/${payload.id || ''}`

    return axios[method](url, payload)
      .then(res => {
        showSuccess('Regra fiscal do produto salva com sucesso!')
        dispatch('get')
        return res
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: async ({ state, dispatch }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/product-fiscal-state-rules/${id}`)
      .then(res => {
        showSuccess('Regra fiscal do produto excluída com sucesso!')
        dispatch('get')
        return res
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
